import { render, staticRenderFns } from "./NewStockDialog.vue?vue&type=template&id=4842fcc4"
import script from "./NewStockDialog.vue?vue&type=script&lang=js"
export * from "./NewStockDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports